import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Eyebrow } from './Eyebrow';
import { PRICE, PRICE_PLN } from '../data/valueStack';
const highlights = ['Gotowe do użycia', 'Semestr zaplanowany', '50 ćwiczeń', '6 tomów', '5 bonusów'];
const assurances = [{
  icon: LockIcon,
  label: 'Bezpieczna płatność'
}, {
  icon: ZapIcon,
  label: 'Natychmiastowy dostęp'
}, {
  icon: ShieldCheckIcon,
  label: '10 dni gwarancji'
}];
export function Hero() {
  return <header id="top" className="bg-night" data-id="element-183" data-mp="x8jj3cboo8cg">
      <div className="mx-auto max-w-shell px-5 pb-12 pt-10 sm:px-6 sm:pb-16 sm:pt-16" data-id="element-184" data-mp="sa9s7dwzrtwn">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-4xl text-center" data-id="element-185" data-mp="nczt16jsw3vm">
          <Eyebrow align="center" data-id="element-186" data-mp="380w0g222h1f9">Dla nauczycieli gitary jazzowej</Eyebrow>
          <h1 className="mt-6 font-display text-[2.4rem] leading-[0.95] sm:text-6xl lg:text-7xl" data-id="element-187" data-mp="3j9k9t8cxxbej">
            <span className="block text-cream" data-id="element-188" data-mp="3o6kfhi5voc54">Znowu niedzielny wieczór</span>
            <span className="block text-amber" data-id="element-189" data-mp="39aupl8xknev4">nad planami lekcji?</span>
          </h1>
        </motion.div>
        <div className="relative mx-auto mt-8 max-w-5xl sm:mt-10" data-id="element-190" data-mp="3e8mtl1bhqrfo">
          <span className="absolute -top-3.5 right-4 z-10 rounded-full bg-amber px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-night sm:-top-4 sm:right-6 sm:px-4 sm:text-xs" data-id="element-191" data-mp="3eb8xmqz6aot5">
            6 tomów + 5 bonusów
          </span>
          <div className="rounded-2xl border border-night-600 bg-night-800 p-2 sm:p-3" data-id="element-192" data-mp="2qkwiow5ifrt2">
            <img src="https://cdn.magicpatterns.com/uploads/vL3a7ZezmJRFuApQTcxmoi/Imagen_de_ChatGPT_30_sept_2026,_12_18_55_p.m..png" alt="Arsenał Nauczyciela Jazzu: tomy, bonusy i materiały na komputerze, tablecie i telefonie" className="w-full rounded-xl" data-id="element-193" data-mp="2vi55xb5imm16" />
          </div>
        </div>
        <p className="mx-auto mt-8 max-w-2xl text-center font-serif text-lg italic leading-snug text-cream-soft sm:text-xl" data-id="element-194" data-mp="s3coeiao1xu9">
          Wchodzisz, patrzysz i uczysz. <span className="text-amber" data-id="element-195" data-mp="ibgod1p0rxne">Wszystko gotowe do użycia.</span>
        </p>
        <ul className="mx-auto mt-6 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-196" data-mp="ddnhe6fw6zm2">
          {highlights.map(item => <li key={item} className="rounded-full border border-night-600 bg-night-800 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-cream-soft sm:text-[11px]" data-id="element-197" data-mp="1azulzgc74ryf">
              {item}
            </li>)}
        </ul>
        <div className="mt-8 flex flex-col items-center gap-3" data-id="element-198" data-mp="x1w789tyqtie">
          <CtaButton size="lg" target="offer" data-id="element-199" data-mp="3lsyrwwxreii0">
            Zobacz ofertę
          </CtaButton>
          <p className="text-center text-xs text-amber-light" data-id="element-200" data-mp="3lqm4w5d59hy3">
            {PRICE} ({PRICE_PLN}) &mdash; płatność jednorazowa, bez subskrypcji.
          </p>
          <div className="mt-1 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-201" data-mp="1xama741tsf59">
            {assurances.map(({
            icon: Icon,
            label
          }) => <span key={label} className="flex items-center gap-2 text-xs text-cream-muted" data-id="element-202" data-mp="218jzs7zid396">
                <Icon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-203" data-mp="26868c44e5vbn" />
                {label}
              </span>)}
          </div>
        </div>
      </div>
    </header>;
}